import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '../pages/HomePage/HomePage';
import LoginPage from '../pages/LoginPage/LoginPage';
import NotFoundPage from '../pages/NotFoundPage';
import UsersPage from '../pages/UsersPage/UsersPage';
import TermsPage from '../pages/TermsPage/TermsPage';
import ProgramsPage from '../pages/ProgramsPage/ProgramsPage';
import SubjectsPage from '../pages/SubjectsPage/SubjectsPage';
import ReferencesPage from '../pages/ReferencesPage/ReferencesPage';
import VideosPage from '../pages/VideosPage/VideosPage';
import PreboardExamineePage from '../pages/PreboardExamineePage/PreboardExamineePage';
import PreboardExamPage from '../pages/PreboardExamPage/PreboardExamPage';

const AppRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/subjects" element={<SubjectsPage />} />
            <Route path="/videos" element={<VideosPage />} />
            <Route path="/references" element={<ReferencesPage />} />
            <Route path="/preboard/examinees" element={<PreboardExamineePage />} />
            <Route path="/preboard/exams" element={<PreboardExamPage />} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
};

export default AppRoutes;